import { setActiveAuctionId } from '@edge/spark/io-roles'
import { type MutationResolvers } from '../../../generated/graphql'

const changeAuction: MutationResolvers['changeAuction'] = (_root, { newAuction }, _ctx) => {
    console.debug('changeAuctionResolver deprecated, use setActiveAuctionId', newAuction)

    if (!newAuction) {
        return false
    }

    setActiveAuctionId(newAuction)

    return true
}

export default changeAuction
